/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../models/transfer';
import '../../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "service": {
            "nested": {
              "CreateTransferRequest": {
                "fields": {
                  "idempotencyKey": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "transfer": {
                    "type": ".squareup.sfs.models.Transfer",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "CreateTransferResponse": {
                "fields": {
                  "transfer": {
                    "type": ".squareup.sfs.models.Transfer",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.service?.nested?.CreateTransferRequest && !$root.nested?.squareup?.nested?.sfs?.nested?.service?.nested?.CreateTransferResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE CreateTransferRequest @ squareup/sfs/services/transfer/create_transfer.proto at 9:1
 */
export const CreateTransferRequest = $root.lookupType('squareup.sfs.service.CreateTransferRequest');
fixType(CreateTransferRequest, {
  idempotencyKey: {
    notEmpty: true
  },
  transfer: {
    required: true
  }
});
Builder.createAndAttachToType(CreateTransferRequest);
/**
 * SOURCE CreateTransferResponse @ squareup/sfs/services/transfer/create_transfer.proto at 23:1
 */
export const CreateTransferResponse = $root.lookupType('squareup.sfs.service.CreateTransferResponse');
fixType(CreateTransferResponse);
Builder.createAndAttachToType(CreateTransferResponse);